import { useEffect, useRef, useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './style.css';
import { Link, useParams } from 'react-router-dom';

//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import Load from '../load/cast';

export default function Cast( { id, season, episode } ) {

    const [ cast, setCast ] = useState([]);
    const image_path = 'https://image.tmdb.org/t/p/w138_and_h175_face';

    const [ castLengthVisible, setCastLengthVisible ] = useState(15);
    const [ loadingCast, setLoadingCast ] = useState(true);
 
    const [ language, setLanguage ] = useState();
    const swiperRef = useRef(null);

    useEffect(()=> {
        setCastLengthVisible(15);
        
        if (swiperRef && swiperRef.current) {
            swiperRef.current.swiper.slideTo(0);
        }
    }, [ id ]);
    
    useEffect(() => {

        setLoadingCast(true);

        var language = localStorage.getItem('idioma') || 'portugues';
        setLanguage(language);
        fetch(`https://api.themoviedb.org/3/tv/${id}/season/${season}${episode ? `/${episode}` : ''}/credits?api_key=${process.env.REACT_APP_TMDB_KEY}&language=${language == 'ingles' ? 'en-US' : 'pt-BR'}`)
        .then(Response => Response.json())
        .then(data => {
            
            setCast(data);
            console.log("Elenco: ", data)
            setLoadingCast(false);

        });

    }, [id, season]);

    const loadMore = () => {
        const remainingElenco = cast.length - castLengthVisible;
        const nextBatch = Math.min(remainingElenco, 10);
        setCastLengthVisible(prevCastLengthVisible => prevCastLengthVisible + nextBatch);
    };

    return (
        <>
            {loadingCast &&
                <div className='div-elenco-season' id='div-elenco-season'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">{language == 'ingles' ? 'Cast' : 'Elenco'}</h2>
                    <Load />
                </div>
            }
            {(cast?.cast && cast?.cast.length >= 1) &&
                <div className='div-elenco-season' id='div-elenco-season'>
                    <h2 className="h2-elenco-details-movie h2-titulo-sections" id="h2-sugestoes">{language == 'ingles' ? 'Cast' : 'Elenco'}</h2>
                    <Swiper
                        slidesPerView={'auto'}
                        spaceBetween={10}
                        freeMode={false}
                        pagination={{
                        clickable: true,
                        }}
                        className="mySwiper swiper-elenco"
                        id="swiper-slide"
                        ref={swiperRef}
                    >
                        {cast?.cast.slice(0, castLengthVisible).map((ator, key) =>{
                            return(
                                <SwiperSlide key={key} className='swiper-slide-elenco'>
                                    <button className='ator-season'>
                                        <img loading="lazy" src={ator.profile_path ? (`${image_path}${ator.profile_path}`) : 'https://dflix.netlify.app/imagens/img-avatar.png'} alt={ator.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src='https://dflix.netlify.app/imagens/img-avatar.png';}}/>
                                        <section className='section-nome-ator-personagem'>
                                            {ator.original_name && 
                                                <span className='nome-ator'>{ator.original_name}</span>
                                            }
                                            <span className='nome-personagem'>{ator.character}</span>
                                        </section>
                                    </button>
                                </SwiperSlide>
                            )
                        })}
                        <SwiperSlide>
                            {cast?.cast.length > castLengthVisible && (
                                <button className='botao-playlist botao-add-playlist bt-more-elenco' onClick={loadMore}><i className='fas fa-chevron-right'></i></button>
                            )}
                        </SwiperSlide>
                        
                    </Swiper>
                </div>
            }
        </>
    )
}